import Enum from "../../../../../../enums/Enum";

const RiskLevelEnum = new Enum({
    LOW_RISK: {name: "Low Risk"},
    HIGH_RISK: {name: "Moderate/High Risk"},
});

export default RiskLevelEnum;